import { createSelector, Selector } from 'reselect'

import { AgentState } from './agent.reducer'

import { filterFalsyValues } from '~/core/helpers/helpers'
import { RootState } from '~/core/store/root.reducer'
import selectFeatureFlags from '~/featureFlags/store/featureFlags.selectors'

type GetAgent = Selector<RootState, AgentState>

export const OFFLINE = 'OFFLINE'
export const ONLINE = 'ONLINE'

export const getAgent: GetAgent = (state) => state.agent

export const selectAvailableBrands: Selector<RootState, string[]> = createSelector(
  getAgent,
  (agent) => agent.data.brand || [],
)
export const selectSaleId = createSelector(getAgent, (agent) => agent.data?.saleId)
export const selectAgentType = createSelector(getAgent, (agent) => agent.data?.type)
export const selectAgentId = createSelector(getAgent, (agent) => agent.data?.userId)

export const selectIsOffline = createSelector(
  selectAgentType,
  selectFeatureFlags,
  (agentType, flags) => agentType === OFFLINE || flags.isOffline,
)

export const selectAgentCenterId = createSelector(getAgent, (agent) => agent.data.centerId)
export const selectAgentForBasket = createSelector(
  getAgent,
  selectIsOffline,
  (agent, isOffline) => {
    return filterFalsyValues({
      dealer: agent.data?.dealer,
      centerId: isOffline ? agent.data?.centerId : undefined,
      type: isOffline ? OFFLINE : agent.data?.type,
    })
  },
)

export const selectDealer = createSelector(getAgent, (agent) => agent.data.dealer)

export const selectAgentName = createSelector(getAgent, (agent) => agent.data.name)
